import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@common/components';
import { SvgHelpQuestionFill } from '@common/icon';
export interface DiscountItem {
  name: string;
  amount: number;
}
interface DiscountTooltipProps {
  items?: DiscountItem[];
}
export const DiscountTooltip = t0 => {
  const $ = _c(7);
  const {
    items
  } = t0;
  if (!items || items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-col gap-4 typo-body3 mobile-tablet:typo-caption1">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SvgHelpQuestionFill className="size-14 text-Gray-500" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <Tooltip theme="outlined" side="bottom" align="start" className="max-w-[25rem]" label={t2}>{t3}</Tooltip>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
function _temp(item, i) {
  return <div key={i} className="flex items-start justify-between gap-16"><span>{item.name}</span><span className="shrink-0">{item.amount > 0 && "-"}{item.amount.toLocaleString()}원</span></div>;
}